import { useMutation } from '~/shared/hooks/query'
import {
  chatV3ChatMessage,
  ChatV3ChatMessagePartialUpdateBodyParams,
  ChatV3ChatMessagePartialUpdatePathParams,
} from '@fireflyhealth/api'

const updateChatMessage = async (
  payload: ChatV3ChatMessagePartialUpdatePathParams &
    Partial<Omit<ChatV3ChatMessagePartialUpdateBodyParams, 'uid'>>,
) => {
  const { data } = await chatV3ChatMessage.partialUpdate(
    {
      uid: payload.uid,
    },
    {
      data: payload,
    },
  )

  return data
}

export const useUpdateChatMessage = () => {
  return useMutation(updateChatMessage, {}, { error: 'Failed to update chat message' })
}
